import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "../../styles/VendorCreation.css";
import axiosInstance from '../../axiosInstance';
import AsyncSelect from "react-select/async";

const VendorCreation = ({ closePopup, editData, onSubmit }) => {
  const [formData, setFormData] = useState({
    vendor_code: '',
    vendor_name: '',
    address: '',
    email: '',
    location: null,
    location_name: '',
    contact_number: '',
    invno_duplicate_from_month: null,
    invno_duplicate_to_month: null
  });
  const [isEditing, setIsEditing] = useState(false);
  const [citySuggestions, setCitySuggestions] = useState([]);

  useEffect(() => {
    if (editData) {
      setIsEditing(true);
      setFormData({
        id: editData.id,
        vendor_code: editData.vendor_code,
        vendor_name: editData.vendor_name,
        address: editData.address || '',
        email: editData.email || '',
        location: editData.location || null,
        location_name: editData.location_name || null,
        contact_number: editData.contact_number || '',
        invno_duplicate_from_month: editData.invno_duplicate_from_month || null,
        invno_duplicate_to_month: editData.invno_duplicate_to_month || null
      });
    }
  }, [editData]);

  const handleClear = () => {
    setFormData({
      vendor_code: '',
      vendor_name: '',
      address: '',
      email: '',
      location: null,
      location_name: '',
      contact_number: '',
      invno_duplicate_from_month: null,
      invno_duplicate_to_month: null
    });
  };

  const monthList = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    const normalizedValue = value === "" ? null : value;

    const updatedForm = {
      ...formData,
      [name]: normalizedValue,
    };

    if (name === "invno_duplicate_from_month" && normalizedValue) {
      const fromIndex = monthList.indexOf(normalizedValue);
      if (fromIndex !== -1) {
        const toIndex = (fromIndex + 11) % 12;
        updatedForm["invno_duplicate_to_month"] = monthList[toIndex];
      }
    }

    setFormData(updatedForm);
  };

  const loadCityOptions = async (inputValue) => {
    try {
      const response = await axiosInstance.get("/vendor/get_cities", {
        params: { term: inputValue }
      });

      if (response.data.success) {
        const suggestions = response.data.autosuggestion;
        setCitySuggestions(suggestions);
        return suggestions;
      }
      return [];
    } catch (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.vendor_code.trim()) {
      toast.error("Vendor Code is required");
      return;
    }

    if (!formData.vendor_name.trim()) {
      toast.error("Vendor Name is required");
      return;
    }

    let submitData = { ...formData };
    if (formData.location_name && !formData.location) {
      try {
        const response = await axiosInstance.post("/vendor/create_city", {
          city_name: formData.location_name
        });

        if (response.data.success) {
          toast.success(`New city "${formData.location_name}" added.`);
          const newCityId = response.data.data.value;

          setFormData(prev => ({
            ...prev,
            location: newCityId
          }));

          submitData = {
            ...submitData,
            location: newCityId
          };
        } else {
          throw new Error("Failed to create city");
        }
      } catch (err) {
        console.error("Failed to create new city:", err);
        toast.error("Failed to create new city.");
        return;
      }
    }
    delete submitData.location_name;

    const success = await onSubmit(submitData);
    if (success) {
      closePopup();
    }
  };

  return (
    <div className="vendor-creation-popup-overlay">
      <div className="vendor-creation-popup-container">
        <div className="vendor-creation-popup-header">
          <h2>{isEditing ? 'Edit Vendor' : 'Create Vendor'}</h2>
          <button className="close-button" onClick={closePopup}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="vendor-creation-popup-body">
            <div className="vendor-form-row-grid">
              <div className="vendor-creation-form-group">
                <label>Vendor Code <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="vendor_code"
                  placeholder="Ex: TJ2025"
                  value={formData.vendor_code}
                  onChange={handleChange}
                  style={{ margin: '0px' }}
                />
              </div>

              <div className="vendor-creation-form-group">
                <label>Vendor Name <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="vendor_name"
                  placeholder="Ex: Test"
                  value={formData.vendor_name}
                  onChange={handleChange}
                  style={{ margin: '0px' }}
                />
              </div>
            </div>

            <div className="vendor-form-row-grid">
              <div className="vendor-creation-form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="abc@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  style={{ margin: '0px' }}
                />
              </div>

              <div className="vendor-creation-form-group">
                <label>Address</label>
                <input
                  type="text"
                  name="address"
                  placeholder="Enter address"
                  value={formData.address}
                  onChange={handleChange}
                  style={{ margin: '0px' }}
                />
              </div>
            </div>

            <div className="vendor-form-row-grid">
              <div className="vendor-creation-form-group">
                <label>Location</label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={loadCityOptions}
                  onChange={(selectedOption, { action }) => {
                    if (action === "select-option" || action === "clear") {
                      setFormData(prev => ({
                        ...prev,
                        location: selectedOption ? selectedOption.value : null,
                        location_name: selectedOption ? selectedOption.label : ""
                      }));
                    }
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      setFormData(prev => ({
                        ...prev,
                        location_name: inputValue,
                        location: null
                      }));
                    }
                    return inputValue;
                  }}
                  value={
                    formData.location_name
                      ? {
                        label: formData.location_name,
                        value: formData.location
                      }
                      : null
                  }
                  placeholder="Select or type location"
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? `Press enter to create "${inputValue}"` : null
                  }
                  menuPortalTarget={document.body}
                  styles={{
                    control: (base) => ({
                      ...base,
                      margin: 0,
                      minHeight: '32px',
                      fontFamily: 'Work Sans',
                      fontSize: '14px',
                      borderRadius: '8px'
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 999,
                      fontSize: '13px',
                      marginTop: '4px',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    }),
                    menuList: (base) => ({
                      ...base,
                      fontFamily: 'Work Sans',
                      maxHeight: '250px',
                      overflowY: 'auto',
                      padding: 0
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    container: base => ({ ...base, width: '100%' }),
                  }}
                />
              </div>

              <div className="vendor-creation-form-group">
                <label>Contact Number</label>
                <input
                  type="number"
                  name="contact_number"
                  placeholder="Enter contact no."
                  value={formData.contact_number}
                  onChange={handleChange}
                  style={{ margin: '0px' }}
                />
              </div>
            </div>

            <div className="vendor-form-row-grid">
              <div className="month-select-row">
                <div className="vendor-creation-form-group">
                  <label>Invoice Duplicate From Month</label>
                  <select
                    name="invno_duplicate_from_month"
                    value={formData.invno_duplicate_from_month}
                    onChange={handleChange}
                    style={{ margin: '0px' }}
                    className="styled-select"
                  >
                    <option value="">Select Month</option>
                    {monthList.map(month => (
                      <option key={month} value={month}>{month}</option>
                    ))}
                  </select>
                </div>

                <div className="vendor-creation-form-group">
                  <label>Invoice Duplicate To Month</label>
                  <select
                    name="invno_duplicate_to_month"
                    value={formData.invno_duplicate_to_month}
                    onChange={handleChange}
                    style={{ margin: '0px' }}
                    className="styled-select"
                  >
                    <option value="">Select Month</option>
                    {monthList.map(month => (
                      <option key={month} value={month}>{month}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="vendor-creation-popup-footer">
            <button type="button" className='vendor-clear-button' onClick={handleClear}>Clear</button>
            <button type="submit" className="vendor-submit-button">
              {isEditing ? 'Update' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VendorCreation;